import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    keywords1: [],
    keywords2: [],
    keywords3: [],
    keywords4: [],
    keywords5: [],
    loading: true,
  },
  mutations: {
    setKeywords1(state, payload) {
      state.keywords1 = payload
    },
    setKeywords2(state, payload) {
      state.keywords2 = payload
    },
    setKeywords3(state, payload) {
      state.keywords3 = payload
    },
    setKeywords4(state, payload) {
      state.keywords4 = payload
    },
    setKeywords5(state, payload) {
      state.keywords5 = payload
    },
  },
  actions: {
    async getKeywords1(context, pillarOne) {
      this.state.loading = true
      const forKeywords1 = []
      firebaseDatabase.collection('keywords')
        .where('userID', '==', firebaseAuth.currentUser.uid)
        .where('active', '==', true)
        .where('pillarID', '==', pillarOne.pillarID)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              keywordID: doc.id,
              pillarID: doc.data().pillarID,
              keywordName: doc.data().keywordName,
              pillarName: doc.data().pillarName,
              active: doc.data().active,
              userID: doc.data().userID,
              minVideos: doc.data().minVideos,
              minViews: doc.data().minViews,
              minSubs: doc.data().minSubs,
              avgVideos: doc.data().avgVideos,
              avgViews: doc.data().avgViews,
              avgSubs: doc.data().avgSubs,
            }
            forKeywords1.push(data)
          })
          context.commit('setKeywords1', forKeywords1)
        })
    },
    async getKeywords2(context, pillarTwo) {
      this.state.loading = true
      const forKeywords2 = []
      firebaseDatabase.collection('keywords')
        .where('userID', '==', firebaseAuth.currentUser.uid)
        .where('active', '==', true)
        .where('pillarID', '==', pillarTwo.pillarID)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              keywordID: doc.id,
              pillarID: doc.data().pillarID,
              keywordName: doc.data().keywordName,
              pillarName: doc.data().pillarName,
              active: doc.data().active,
              userID: doc.data().userID,
              minVideos: doc.data().minVideos,
              minViews: doc.data().minViews,
              minSubs: doc.data().minSubs,
              avgVideos: doc.data().avgVideos,
              avgViews: doc.data().avgViews,
              avgSubs: doc.data().avgSubs,
            }
            forKeywords2.push(data)
          })
          context.commit('setKeywords2', forKeywords2)
        })
    },
    async getKeywords3(context, pillarThree) {
      this.state.loading = true
      const forKeywords3 = []
      firebaseDatabase.collection('keywords')
        .where('userID', '==', firebaseAuth.currentUser.uid)
        .where('active', '==', true)
        .where('pillarID', '==', pillarThree.pillarID)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              keywordID: doc.id,
              pillarID: doc.data().pillarID,
              keywordName: doc.data().keywordName,
              pillarName: doc.data().pillarName,
              active: doc.data().active,
              userID: doc.data().userID,
              minVideos: doc.data().minVideos,
              minViews: doc.data().minViews,
              minSubs: doc.data().minSubs,
              avgVideos: doc.data().avgVideos,
              avgViews: doc.data().avgViews,
              avgSubs: doc.data().avgSubs,
            }
            forKeywords3.push(data)
          })
          context.commit('setKeywords3', forKeywords3)
        })
    },
    async getKeywords4(context, pillarFour) {
      this.state.loading = true
      const forKeywords4 = []
      firebaseDatabase.collection('keywords')
        .where('userID', '==', firebaseAuth.currentUser.uid)
        .where('active', '==', true)
        .where('pillarID', '==', pillarFour.pillarID)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              keywordID: doc.id,
              pillarID: doc.data().pillarID,
              keywordName: doc.data().keywordName,
              pillarName: doc.data().pillarName,
              active: doc.data().active,
              userID: doc.data().userID,
              minVideos: doc.data().minVideos,
              minViews: doc.data().minViews,
              minSubs: doc.data().minSubs,
              avgVideos: doc.data().avgVideos,
              avgViews: doc.data().avgViews,
              avgSubs: doc.data().avgSubs,
            }
            forKeywords4.push(data)
          })
          context.commit('setKeywords4', forKeywords4)
        })
    },
    async getKeywords5(context, pillarFive) {
      this.state.loading = true
      const forKeywords5 = []
      firebaseDatabase.collection('keywords')
        .where('userID', '==', firebaseAuth.currentUser.uid)
        .where('active', '==', true)
        .where('pillarID', '==', pillarFive.pillarID)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              keywordID: doc.id,
              pillarID: doc.data().pillarID,
              keywordName: doc.data().keywordName,
              pillarName: doc.data().pillarName,
              active: doc.data().active,
              userID: doc.data().userID,
              minVideos: doc.data().minVideos,
              minViews: doc.data().minViews,
              minSubs: doc.data().minSubs,
              avgVideos: doc.data().avgVideos,
              avgViews: doc.data().avgViews,
              avgSubs: doc.data().avgSubs,
            }
            forKeywords5.push(data)
          })
          context.commit('setKeywords5', forKeywords5)
        })
    },
  },
  getters: {
    state: state => state,
  },
}
